export default "__VITE_PUBLIC_ASSET__29bedf58__"